<ui-page-container size="medium">
  <mat-card class="profile-page-content">
    <mat-card-title>
      <p class="card-inner-title">
        {{ (entityId ? 'Modifica Matrice incisa' : 'Aggiungi Matrice incisa') | translate }}
        <span *ngIf="entityForm?.value?.SGT?.SGTT">: {{ entityForm?.value?.SGT?.SGTT }}</span>
      </p>
      <div
        class="alert-role"
        *roleVisibility="['create', 'update']; classNames: ['BeneMI']; behaviour: 'show'">
        <p>
          {{ 'Il tuo ruolo ti permette solamente di visualizzare le informazioni relative alla matrice incisa.' | translate }}
        </p>
        <p>
          {{ 'Nessuna azione di modifica avrà effetto.' | translate }}
        </p>
      </div>
    </mat-card-title>
    <mat-card-content class="card-container">
      <aside>
        <img
          *ngIf="imageUrl; else imagePlaceholder"
          loading="lazy"
          [src]="imageUrl"
          (click)="showMediaHandler()">

        <ng-template #imagePlaceholder>
          <img
            class="card-image-placeholder"
            loading="lazy"
            src="./assets/images/card-placeholder.png"
            (click)="tabChangeHandler({ index: 4 })">
        </ng-template>
        <div class="card-general-actions">
          <button *ngIf="originalImageDownloadUrl"
                  mat-stroked-button
                  color="primary"
                  class="card-download-btn"
                  type="button"
                  (click)="downloadOriginalImage()">
            Scarica immagine originale
          </button>
          <app-card-actions
            *ngIf="entityId"
            className="BeneMI"
            cardType="mi"
            [entity]="entityForm?.value"
            [cardName]="entityForm?.value?.codiceUnico"
            [entityId]="entityId"
            (changeStatus)="changeStatusHandler($event)">
          </app-card-actions>
        </div>
      </aside>

      <form
        *ngIf="entityForm"
        [formGroup]="entityForm"
        (ngSubmit)="dispatchAction(entityForm)">
        <div class="direct-nav-group">
          <button
            *ngIf="entityId"
            color="link"
            class="card-submit-btn"
            mat-raised-button
            #collectionsTrigger="matMenuTrigger"
            [matMenuTriggerFor]="collectionsMenu"
            [disabled]="collections.length === 0 || collectionsLoading"
            (click)="$event.preventDefault()"
            (mouseenter)="collections.length > 0 && !collectionsLoading && collectionsTrigger.openMenu()">

            <mat-spinner 
              *ngIf="collectionsLoading" 
              diameter="20" 
              style="display: inline-block; margin-right: 8px;">
            </mat-spinner>
            <span *ngIf="collectionsLoading">{{ 'Caricamento collezioni...' | translate }}</span>
            <span *ngIf="!collectionsLoading && collections.length > 0">{{ 'Collezioni' | translate }}</span>
            <span *ngIf="!collectionsLoading && collections.length === 0">{{ 'Nessuna collezione' | translate }}</span>

          </button>

          <mat-menu #collectionsMenu="matMenu">
            <button 
              mat-menu-item 
              *ngFor="let collection of collections"
              (click)="navigateToCollection(collection.id)">
              {{ collection.titolo }}
            </button>
          </mat-menu>
        </div>

        <button
          *roleVisibility="['create', 'update']; classNames: ['BeneMI']"
          class="card-submit-btn"
          type="submit"
          color="primary"
          mat-raised-button>
          {{ (entityId ? 'Salva' : 'Crea') | translate }}
        </button>
        <mat-tab-group
          animationDuration="0ms"
          [@.disabled]="true"
          [selectedIndex]="activeTabIndex"
          (selectedTabChange)="tabChangeHandler($event)">
          <mat-tab [label]="'ICCD' | translate">
            <app-iccd-manager
              [form]="entityForm"
              [classNames]="['BeneMI']">
            </app-iccd-manager>
          </mat-tab>
          <mat-tab [label]="'Informazioni generali' | translate">
            <app-info-card-manager [form]="entityForm"></app-info-card-manager>
          </mat-tab>
          <mat-tab [label]="'Fonti bibliografiche' | translate">
            <app-source-bib-manager
              *ngIf="activatedTabs[2]"
              [cardId]="entityId"
              [form]="entityForm.get('fontiBib')"
              [classNames]="['BeneMI']">
            </app-source-bib-manager>
          </mat-tab>
          <mat-tab [label]="'Fonti archivistiche' | translate">
            <app-source-arc-manager
              *ngIf="activatedTabs[3]"
              [cardId]="entityId"
              [form]="entityForm.get('fontiArc')"
              [classNames]="['BeneMI']"></app-source-arc-manager>
          </mat-tab>
          <mat-tab [label]="'Allegati' | translate">
            <app-attachments-manager
              *ngIf="activatedTabs[4]"
              [form]="entityForm.get('allegati')"
              [classNames]="['BeneMI']">
            </app-attachments-manager>
          </mat-tab>
          <mat-tab [label]="'Movimenti' | translate">
            <app-movementss-manager
              [form]="entityForm.get('movimenti')"
              [classNames]="['BeneMI']"></app-movementss-manager>
          </mat-tab>
          <mat-tab [label]="'Restauri' | translate">
            <app-restorations-manager
              [form]="entityForm.get('restauri')"
              [classNames]="['BeneMI']"></app-restorations-manager>
          </mat-tab>
        </mat-tab-group>
      </form>
    </mat-card-content>
  </mat-card>
</ui-page-container>
